<div id="{{theme}}-app" class="{{theme}}-preview-banner-dialog">
    <div mat-dialog-title>
        <div class="row">
            <div class="col-md-10">
            </div>
            <div class="col-md-2">
                <span style="cursor: pointer;" class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>

    <div>
        <app-banner [bannerId]="bannerId"></app-banner>
        <div class="text-center">
            <app-dashboard [feature]="featureInfo"></app-dashboard>
        </div>
    </div>
</div>